import {
  GET_DISCOVERY_LOCATIONS,
  GET_DISCOVERY_LOCATIONS_FAILED,
  GET_DISCOVERY_LOCATIONS_SUCCESS,
  DELETE_DISCOVERY_LOCATION,
  DELETE_DISCOVERY_LOCATION_FAILED,
  DELETE_DISCOVERY_LOCATION_SUCCESS,
} from './actionTypes';

export const actionGetDiscoveryLocations = (payload) => ({
  payload,
  type: GET_DISCOVERY_LOCATIONS,
});

export const actionGetDiscoveryLocationsSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_LOCATIONS_SUCCESS,
});

export const actionGetDiscoveryLocationsFailed = (payload) => ({
  payload,
  type: GET_DISCOVERY_LOCATIONS_FAILED,
});

export const actionDeleteDiscoveryLocation = (payload) => ({
  payload,
  type: DELETE_DISCOVERY_LOCATION,
});

export const actionDeleteDiscoveryLocationSuccess = (payload) => ({
  payload,
  type: DELETE_DISCOVERY_LOCATION_SUCCESS,
});

export const actionDeleteDiscoveryLocationFailed = (payload) => ({
  payload,
  type: DELETE_DISCOVERY_LOCATION_FAILED,
});
